import { Component, Prop, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import axios from "axios";
@Component({
  components: {
    AppLoaderComponent,
  },
})
export default class PreviewPopupComponent extends Vue {
  @Prop()
  public fileDetails!: any[];
  @Prop()
  public keyName!: string;
  @Prop()
  public typeOfView!: string;
  @Prop()
  public isPeerPreview!: any;

  public S3Path = "";
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public docType = ["pdf", "doc", "document"];
  public isLoading = false;
  public slideIndex = 0;
  public totalLength = 0;

  public mounted() {
    let getFileType = "";
    this.$nextTick().then(() => {
      this.totalLength = this.fileDetails.length;
      this.fileDetails.length &&
        this.fileDetails.map((file: any) => {
          if (file.slug && file.slug === "download-handbook") {
            this.S3Path = appConfigService.getS3FormPathUrl();
          } else {
            this.S3Path =
              this.typeOfView === "certificate" || this.isPeerPreview
                ? appConfigService.getS3CertificatesFilesPathUrl()
                : appConfigService.getS3FilesPathUrl();
          }
          getFileType =
            file && file.uploadedFileName
              ? file.uploadedFileName.split(".")[1]
              : file.fileName
              ? file.fileName.split(".")[1]
              : file.type.split("/")[1];
          file.type = getFileType;
          if (this.docType.includes(getFileType)) {
            file.isDocument = true;
            file.isImage = false;
            file.isWordDoc = false;
          } else if (file.type.includes("docx")) {
            file.isDocument = false;
            file.isImage = false;
            file.isWordDoc = true;
          } else {
            file.isDocument = false;
            file.isImage = true;
            file.isWordDoc = false;
          }
        });
      this.isLoading = true;
      this.$bvModal.show(`preview-modal-center-` + this.keyName);
    });
  }

  public hide(event: any) {
    if (event) {
      this.$emit("hidePreviewPopup", true);
    }
  }
  public async downloadImageFromServer(data: any, getImageName: any) {
    try {
      const response = await axios({
        url: data,
        method: "GET",
        responseType: "blob",
      });
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = getImageName;
      link.click();
    } catch (error) {
      console.error(error);
    }
  }

  public loadData(event: any) {
    this.isLoading = false;
  }

  public prev() {
    if (this.slideIndex <= this.totalLength - 1 && this.slideIndex != 0) {
      this.isLoading = true;
      this.slideIndex--;
    }
  }
  public next() {
    if (this.slideIndex < this.totalLength - 1) {
      this.isLoading = true;
      this.slideIndex++;
    }
  }

  public closePopup() {
    this.$bvModal.hide(`preview-modal-center-` + this.keyName);
    this.slideIndex = 0;
  }
}
